"use strict";
module.exports = require('../../module.compiled').vendored['react-rsc'].ReactJsxRuntime;

//# sourceMappingURL=react-jsx-runtime.js.map